import React, { useEffect, useState } from 'react';
import firebase from 'firebase';
import { Route, Switch } from 'react-router-dom';
import Home from './components/screens/Home';
import Details from './components/screens/Details';
import SearchForm from './components/SearchForm';
import { Redirect } from 'react-router-dom';
import { render } from '@testing-library/react';
import { Fragment } from "react";
import logo from './img/logo-title.png';
import { BrowserRouter as Router } from "react-router-dom";
import Auth from './components/screens/Auth';

const App = () => {

    const [user, setUser] = useState(null);

    useEffect(() => {
        const unsubscribe = firebase.auth().onAuthStateChanged((firebaseUser) => {
            if (firebaseUser) {
                // console.log('i have a user');
                setUser(firebaseUser);
            } else {
                // console.log('i dont have a user');
            }
        });
        return () => {
            unsubscribe();
        }
    }, []);

    return (
        <div>
            <Router>
                <Route path="/about"  component={About} />
                <Route path="/favorites"  component={Favorites} />
            </Router>
            <Switch>
                <Route exact path="/" >
                    <div>
                        <SearchForm destName="deftype" destType="definput" user={user}></SearchForm>
                        <Home />
                    </div>
                </Route>
                <Route path="/details/:city">
                    <Details currCity="udisgtrict" user={user}/>
                </Route>
                <Route path="/auth/:authType">
                    <Auth />
                </Route>
            </Switch>
        </div>
    )
}

// About Page
const About = (props) => {
    const [authType, setAuthType] = useState(null);

    const onPressAuth = (aType) => {
        setAuthType(aType)
    }

    if (authType) {
        return <Redirect push to={`/auth/${authType}`} />;
    }
    return (
        <div>
            <img className="logo" src={logo} alt="touristy page logo"></img>
            <div>
                <ul id="nav">
                    <li><a href="/">Home</a></li>
                    <li><a href="/about">About</a></li>
                    <li><a href="/favorites">Favorites</a></li>
                    {/* <li><a onClick={() => { onPressAuth('signIn')}}>Sign In</a></li>
                    <li><a onClick={() => { onPressAuth('signUp')}}>Sign Up</a></li> */}
                </ul>
            </div>
            <div style={{margin: '2em'}}>
                <h1>About</h1>
                <h4>Our Goals</h4>
                <p>
                    Touristy is an interactive travel recommendation app for users of all ages to experience the great places to 
                    travel around the world while being safe. In quarantine, each of our mental health take a hit,
                    and we feel that by traveling we can do what excites and find happiness and purpose. That is why we created 
                    a service that provides traveling information and a personal touch by recommending “authentic” local experience.

                    We hope our users, young college students deprived of traveling from the pandemic, can utilize this platform to
                    look for information regarding various travel destinations around the world. Our strategy of learning about our users
                    preferences, presenting travel data in a visually encapsulating way,
                    and authentic approach by incorporating our own recommendations will allow the users to thrive in their post-quarantine
                    vacation and achieve our goal of making our users <i>“travel safe and happy.”</i> We aim to bring
                    happiness and improvement in users’ mental health, especially after the pandemic. We believe that our app will be a unique
                    and inspiring platform for our users to find and do what excites them in their next chapter of their lives.
                </p>
            </div>
        </div>
    )

};



// Favorites Page
const Favorites = (props) => {
    const [authType, setAuthType] = useState(null);

    const onPressAuth = (aType) => {
        setAuthType(aType)
    }

    if (authType) {
        return <Redirect push to={`/auth/${authType}`} />;
    }
    return (
        <div>
            <img className="logo" src={logo} alt="touristy page logo"></img>
            <div>
                <ul id="nav">
                    <li><a href="/">Home</a></li>
                    <li><a href="/about">About</a></li>
                    <li><a href="/favorites">Favorites</a></li>
                    {/* <li><a onClick={() => { onPressAuth('signIn')}}>Sign In</a></li>
                    <li><a onClick={() => { onPressAuth('signUp')}}>Sign Up</a></li> */}
                </ul>
            </div>
            <div style={{margin: '2em'}}>
                <h1>Favorites</h1>
            </div>
        </div>
    )

};


export default App;
